import { Action } from '@ngrx/store';

export const SUBMIT_REGISTER_FORM = 'SUBMIT_REGISTER_FORM';

export class SubmitRegisterForm implements Action {
  readonly type = SUBMIT_REGISTER_FORM;
}

export type RegisterActions = SubmitRegisterForm;
